"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "content-new-services"
  }, [_c("div", {
    staticClass: "columns"
  }, [_vm._m(0), _vm._v(" "), _c("div", {
    staticClass: "column"
  }, [_c("header-filter", {
    attrs: {
      placeholder: "Busque pelo nome do serviço"
    },
    model: {
      value: _vm.filter,
      callback: function callback($$v) {
        _vm.filter = $$v;
      },
      expression: "filter"
    }
  })], 1)]), _vm._v(" "), _c("div", {
    staticClass: "columns cols-cards-info is-multiline"
  }, _vm._l(_vm.list, function (item, idx) {
    return _c("div", {
      key: idx,
      staticClass: "column is-one-third"
    }, [_c("card-monitor", {
      attrs: {
        title: "",
        service: _vm._f("toUpperCase")(item.Name),
        logo: item.Logo,
        active: item.Active,
        cost: item.Price
      },
      nativeOn: {
        click: function click($event) {
          return _vm.openDetailService(item);
        }
      }
    })], 1);
  }), 0)]);
};
exports.render = render;
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "column"
  }, [_c("h1", {
    staticClass: "title-page"
  }, [_vm._v("Serviços disponíveis")])]);
}];
exports.staticRenderFns = staticRenderFns;
render._withStripped = true;